import React from 'react'

import './List.css'

import ListInput from './ListInput'
import CardsList from './CardsList'

const List = (props) =>
  <div className="list">
    <h1>{props.title}</h1>
    {/*<p className="date-text">{props.text}</p>*/}
    <ListInput date={props.newItemDate} items={props.items} />
    <div className="list-cards">
      <CardsList id={props.id} items={props.items} />
    </div>
  </div>

  export default List



// WEBPACK FOOTER //
// ./src/components/List.js